import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var path = process.env.VUE_APP_BASE_API;
import { mapGetters } from 'vuex';
import { ExpressImage } from '@/utils/image';
export default {
  name: 'UploadImage',
  model: {
    prop: 'imageUrl',
    event: 'change'
  },
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    tips: {
      type: String,
      default: ''
    },
    fileSize: {
      type: Number,
      default: 2048 // 2M 超出后执行压缩

    },
    maxWH: {
      type: Number,
      default: 1920 // 图片长宽上限

    },
    multiple: {
      type: Boolean,
      default: false // 是否多选

    },
    autoUpload: {
      type: Boolean,
      default: false // 是否多选

    },
    isPress: {
      type: Boolean,
      default: true // 是否多选

    },
    param: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    }
  },
  data: function data() {
    return {
      path: path,
      fileArr: []
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  methods: {
    beforeImageUpload: function beforeImageUpload(file) {
      // 压缩
      var isRightSize = file.size / 1024 < this.fileSize;

      if (this.isPress && this.isImage(file) && !isRightSize) {
        return ExpressImage.compress(null, file, this.fileSize, this.maxWH);
      }

      return true;
    },
    handleImageSuccess: function handleImageSuccess(res, file, fileList) {
      if (res.code == 0) {
        file.imgUrl = res.data.file.url;
        this.$emit('onUploadSuccess', res);
      } else {
        file.status = 'fail';
        this.$message({
          type: 'error',
          message: res.msg
        });
      }
    },
    onChange: function onChange(file, fileList) {
      var that = this;
      that.fileArr = fileList.filter(function (item) {
        return item.status !== 'success' || !that.multiple;
      }); // 压缩

      var isRightSize = file.size / 1024 < that.fileSize;

      if (that.isPress && that.isImage(file) && !isRightSize) {
        ExpressImage.compress(file, file.raw, that.fileSize, that.maxWH);
      }
    },
    onRemove: function onRemove(file, fileList) {
      this.fileArr = fileList;
    },
    submitUpload: function submitUpload() {
      this.$refs.multipleUpload.uploadFiles.forEach(function (item) {
        item.status = 'ready';
      });
      this.$refs.multipleUpload.submit();
    },
    isImage: function isImage(file) {
      return file.raw && file.raw.type.indexOf('image') !== -1 || file.type.indexOf('image') !== -1;
    },
    onDelImg: function onDelImg(index) {
      this.fileArr.splice(index, 1);
    },
    onPressSizeChange: function onPressSizeChange() {
      var that = this;
      this.fileArr.forEach(function (file) {
        // 压缩
        var isRightSize = file.size / 1024 < that.fileSize;

        if (that.isPress && that.isImage(file) && !isRightSize) {
          ExpressImage.compress(file, file.raw, that.fileSize, that.maxWH);
        }
      });
    }
  }
};